var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_247_16000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 16,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.032 16.8C13.0696 16.8 16.372 11.8749 16.372 7.60437C16.372 7.46417 16.372 7.32476 16.3624 7.18614C17.0048 6.72931 17.5592 6.16221 18 5.5132C17.4016 5.77469 16.7656 5.9464 16.1152 6.02201C16.8 5.61796 17.3128 4.98312 17.5584 4.23408C16.9136 4.61057 16.2088 4.876 15.4736 5.01857C14.2304 3.71739 12.1512 3.65438 10.8288 4.87837C9.9768 5.66758 9.6144 6.8443 9.8792 7.96668C7.24 7.83593 4.7808 6.6088 3.1136 4.59009C2.2424 6.06691 2.688 7.95565 4.1304 8.90397C3.608 8.889 3.0968 8.75038 2.64 8.49991V8.54087C2.6408 10.0791 3.7424 11.4039 5.2736 11.7087C4.7904 11.8387 4.2832 11.8576 3.792 11.7639C4.2216 13.0808 5.4544 13.9826 6.8584 14.0086C5.696 14.9081 4.26 15.3964 2.7816 15.3949C2.5208 15.3941 2.26 15.3791 2 15.3484C3.5016 16.2967 5.248 16.8 7.032 16.7976",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_247_16000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.032 16.8C13.0696 16.8 16.372 11.8749 16.372 7.60437C16.372 7.46417 16.372 7.32476 16.3624 7.18614C17.0048 6.72931 17.5592 6.16221 18 5.5132C17.4016 5.77469 16.7656 5.9464 16.1152 6.02201C16.8 5.61796 17.3128 4.98312 17.5584 4.23408C16.9136 4.61057 16.2088 4.876 15.4736 5.01857C14.2304 3.71739 12.1512 3.65438 10.8288 4.87837C9.9768 5.66758 9.6144 6.8443 9.8792 7.96668C7.24 7.83593 4.7808 6.6088 3.1136 4.59009C2.2424 6.06691 2.688 7.95565 4.1304 8.90397C3.608 8.889 3.0968 8.75038 2.64 8.49991V8.54087C2.6408 10.0791 3.7424 11.4039 5.2736 11.7087C4.7904 11.8387 4.2832 11.8576 3.792 11.7639C4.2216 13.0808 5.4544 13.9826 6.8584 14.0086C5.696 14.9081 4.26 15.3964 2.7816 15.3949C2.5208 15.3941 2.26 15.3791 2 15.3484C3.5016 16.2967 5.248 16.8 7.032 16.7976",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e6a3bdf07e4dc14fa9784060053e12b5.svg";
export { ForwardRef as ReactComponent };